import React, { createContext, useContext, useMemo } from 'react';
import { useUser } from '@descope/react-sdk';

const SessionDataContext = createContext<any | null>(null);

export const SessionDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useUser();
  const value = useMemo(() => ({ user }), [user]);
  return (
    <SessionDataContext.Provider value={value}>
      {children}
    </SessionDataContext.Provider>
  );
};

export const useSessionData = () => useContext(SessionDataContext);
